import { createFileRoute } from '@tanstack/react-router'
import { boardQuery } from '~/features/tactics/queries'
import { BoardPage } from '~/features/tactics/BoardPage'

export const Route = createFileRoute('/_app/taktik/$boardId')({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(boardQuery(params.boardId)).catch(() => undefined)
  },
  component: function Board() {
    return <BoardPage boardId={Route.useParams().boardId} />
  },
})
